module.exports = __webpack_public_path__ + "static/media/logo.394ca318.png";